import script from "./DomainModelNestedEntity.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainModelNestedEntity.vue?vue&type=script&setup=true&lang=js"

import "./DomainModelNestedEntity.vue?vue&type=style&index=0&id=4c5da4aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c5da4aa"]])

export default __exports__